import type { ReactNode } from "react"

import { CheckoutEvents } from "@/components/checkout-events"
import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"
import { useQuizEmailCapture } from "@/hooks/use-quiz-email-capture"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  useQuizEmailCapture()
  return (
    <>
      {children}
      <CheckoutEvents />
      <Toaster position="top-center" richColors />
    </>
  )
}
